import { render } from "./UpdateSuccessModal.vue?vue&type=template&id=3580e184"
import script from "./UpdateSuccessModal.vue?vue&type=script&lang=js"
export * from "./UpdateSuccessModal.vue?vue&type=script&lang=js"
script.render = render

export default script